/**
 * Legacy condition helper functions for backwards compatibility
 * These handle generic condition types and basic operations
 */

/**
 * Convert equals condition to JavaScript expression
 */
export function convertEqualsCondition(fieldKey: string, matchValue: any): string {
	// Use bracket notation for safer property access (handles any field key including long hex strings)
	const modelAccess = `model['${fieldKey}']`;

	if (matchValue === true || matchValue === 'true') {
		return `${modelAccess} === true`;
	}
	if (matchValue === false || matchValue === 'false') {
		return `${modelAccess} === false`;
	}
	if (typeof matchValue === 'number') {
		return `${modelAccess} == ${matchValue}`;
	}
	if (typeof matchValue === 'string') {
		return `${modelAccess} == ${formatValue(matchValue)}`;
	}
	return `${modelAccess} == ${formatValue(matchValue)}`;
}

/**
 * Convert not-equals condition to JavaScript expression
 */
export function convertNotEqualsCondition(fieldKey: string, matchValue: any): string {
	const modelAccess = `model['${fieldKey}']`;

	if (matchValue === true || matchValue === 'true') {
		return `${modelAccess} !== true`;
	}
	if (matchValue === false || matchValue === 'false') {
		return `${modelAccess} !== false`;
	}
	if (typeof matchValue === 'number') {
		return `${modelAccess} != ${matchValue}`;
	}
	if (typeof matchValue === 'string') {
		return `${modelAccess} != ${formatValue(matchValue)}`;
	}
	return `${modelAccess} != ${formatValue(matchValue)}`;
}

/**
 * Convert contains condition to JavaScript expression (for arrays/strings)
 */
export function convertContainsCondition(fieldKey: string, matchValue: any): string {
	const modelAccess = `model['${fieldKey}']`;

	return `(${modelAccess} && ${modelAccess}.includes('${formatValue(matchValue)}'))`;
}

/**
 * Convert not-contains condition to JavaScript expression
 */
export function convertNotContainsCondition(fieldKey: string, matchValue: any): string {
	const modelAccess = `model['${fieldKey}']`;

	return `(!${modelAccess} || !${modelAccess}.includes('${formatValue(matchValue)}'))`;
}

/**
 * Format a value for use in a JavaScript expression
 */
export function formatValue(value: any): string {
	if (value === null || value === undefined) {
		return 'null';
	}
	if (typeof value === 'string') {
		// Check if string is a number - if so, return as number for cleaner expressions
		const numValue = Number(value);
		if (!isNaN(numValue) && value.trim() !== '') {
			return String(numValue);
		}
		// Escape quotes in string
		return `'${value.replace(/'/g, "\\'")}'`;
	}
	if (typeof value === 'boolean') {
		return value ? 'true' : 'false';
	}
	if (typeof value === 'number') {
		return String(value);
	}
	// For objects/arrays, use JSON.stringify
	return JSON.stringify(value);
}
